import fetchAPI from '../utils/fetchAPI';
import URLbuilder from '../utils/URLBuilder';

const getCompactForms = ({ limit = '' }) => {
  let url = '/forms/v1/forms';

  if (limit) {
    limit = `limit=${limit}`;
  }

  const fullUrl = URLbuilder(url, 'compact=true', limit);

  return fetchAPI(fullUrl);
};

const FormsService = {
  getCompactForms
};

export default FormsService;
